import React from "react";
import { useSelector } from "react-redux";
import ArquivosGEEQUIP from './ArquivosGEEQUIP'
import ArquivosSuporte from './ArquivosSuporte'
import { Container } from '@mui/material';
import NotionCard from "./NotionCard";

export default function TableColaboradores() {
  const role = useSelector((state) => state.auth.selectedAccess.role)

  const visibilityByRole = {
    admin: 'all',
    analist: 'internal',
    doorman: 'internal',
    contractor: 'external'
  };

  const visibility = visibilityByRole[role];

  return (
      <Container maxWidth="xl">
        <NotionCard />
        <ArquivosGEEQUIP />
        {visibility !== 'none' && <ArquivosSuporte />}
      </Container>
  );

}



